import { client } from '@atlassian/rovo-content-bridge-api/client-types';

export const JSM_QUEUE_SETTINGS_CLIENT_ID = client('jsm-queue-settings');
